module.exports = __webpack_public_path__ + "img/Alarm.9069c0da.svg";